import ChangePwd from 'pages/ChangePwd'
import HomeOperator from 'pages/HomeOperator'
import MyQrCode from 'pages/MyQrCode/MyQrCode'
import Notifications from 'pages/notification/Notifications'
import Refund from 'pages/refund/Refund'
import Reports from 'pages/reports/Reports'
import TransactionManager from 'pages/transaction_manager/TransactionManager'
import SharedLayout from 'utils/SharedLayout'
import { HomeRedirect } from './HomeRedirect'

const OperatorRoutes = {
  // All common routes
  path: '/',
  element: <SharedLayout />,
  children: [
    {
      path: '/dashboard-operator',
      element: <HomeOperator />
    },
    {
      path: '/my-transactions',
      element: <TransactionManager />
    },
    {
      path: '/reports',
      element: <Reports />
    },
    {
      path: '/refund',
      element: <Refund />
    },
    {
      path: '/change_pwd',
      element: <ChangePwd />
    },
    {
      path: '/notifications',
      element: <Notifications />
    },
    {
      path: '/my-qrcode',
      element: <MyQrCode />
    },
    {
      path: '*',
      element: <HomeRedirect to='/dashboard-operator' />
    }
  ]
}

export default OperatorRoutes
